export default __webpack_public_path__ + "static/media/3-min.5cb86e4c.jpg";